import { API_URL } from './config';

/**
 * Build an absolute URL under the Worker API base (`/api` prefix included in API_URL).
 * @param {string} path - e.g. `/campaigns` or `campaigns`
 */
export function apiUrl(path) {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${API_URL}${p}`;
}

/**
 * fetch() to the Worker with Cloudflare Access cookies / JWT-friendly CORS.
 * Always sets credentials: 'include' for protected routes.
 */
export function apiFetch(path, init = {}) {
  const url =
    typeof path === 'string' && path.startsWith('http') ? path : apiUrl(path);
  return fetch(url, {
    credentials: 'include',
    ...init,
  });
}
